import { Component, OnInit } from "@angular/core";
import { MatDialogRef, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader } from "@angular/material/expansion";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormField, MatInput } from "@angular/material/input";
import { NotCopyPasteDirective } from "../../utilerias/directives/not-copy-paste.directive";
import { CommonModule } from "@angular/common";
@Component({
    selector: "app-modaladduser",
    standalone: true,
    templateUrl: "./modaladduser.component.html",
    styleUrls: ["./modaladduser.component.css"],
    imports: [FormsModule,
      ReactiveFormsModule,
      CommonModule,MatIconButton, MatIcon, CdkScrollable, MatDialogContent, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, FormsModule, ReactiveFormsModule, MatFormField, MatInput, NotCopyPasteDirective, MatDialogActions, MatButton]
})
export class ModaladduserComponent implements OnInit {

  formUser :any;
  formGroupUser:any;


  constructor(
    public dialogRef: MatDialogRef<ModaladduserComponent>
  ) /* private formBuilder: FormBuilder */ {}

  ngOnInit() {}
  onClicCerrarModal(): void {
    this.dialogRef.close();
  }
  ClickGuardar(): void {
    this.dialogRef.close();
  }



}
